export default function scrollToHash(as) {
  // From: https://github.com/zeit/next.js/blob/8e9b84bf2a693b45c6acfdf113a0f38b69d531fc/lib/router/router.js#L326-L346
  const [, hash] = as.split('#');
  // Scroll to top if the hash is just `#` with no value
  if (hash === '') {
    window.scrollTo(0, 0);
    return;
  }

  // First we check if the element by id is found
  const idEl = document.getElementById(hash);
  if (idEl) {
    idEl.scrollIntoView({ block: 'start', behavior: 'smooth' });
    return;
  }
  // If there's no element with the id, we check the `name` property
  // To mirror browsers
  const nameEl = document.getElementsByName(hash)[0];
  if (nameEl) {
    nameEl.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
}
